<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="h-screen flex w-full bg-img"
    :style="`background-image: url('/assets/images/pages/login-bg_${appFilename}.jpg')`"
  >
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Redefinir senha</h4>
                  <p>Escolha sua nova senha.</p>
                </div>
                <vs-input type="password" label-placeholder="Nova senha" v-model="password" class="w-full mb-6" />
                <vs-input type="password" label-placeholder="Confirmar nova senha" v-model="password_confirmation" class="w-full mb-8" />

                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                  <vs-button type="border" to="/pages/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto"
                    >Voltar para o login</vs-button
                  >
                  <vs-button class="w-full sm:w-auto" @click="resetPassword">Redefinir</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      token: '',
      email: '',
      password: '',
      password_confirmation: '',
      appFilename: process.env.VUE_APP_FILENAME,
    };
  },
  mounted() {
    this.token = this.$route.query.token || '';
    this.email = this.$route.query.email || '';
  },
  methods: {
    resetPassword() {
      this.$api
        .post('/api/v1/auth/resetPassword', {
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
        })
        .then(() => {
          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: 'Senha redefinida com sucesso. Faça login com sua nova senha.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
          });

          this.$router.push('/pages/login');
        })
        .catch(error => {
          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.error || error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        });
    },
  },
};
</script>
